import { Typography } from '@/components/common';
import { Title } from '../title';
import Image from 'next/image';
import Images from '@/const/images';

export const WhoWeAre: React.FC = () => {
	return (
		<div className="px-10 lg:px-20 3xl:px-[252px]">
			<div className="bg-gray-15 rounded-3xl lg:rounded-[64px] w-full pt-10 lg:pt-24 pb-14 lg:mb-[112px] relative px-5">
				<Title>
					Who <span className="text-primary">We Are</span>
				</Title>
				<Typography
					type="regular-24"
					className="text-center mb-10 lg:mt-14 max-w-[832px] mx-auto"
				>
					Claim Magic is an innovative legal platform backed by Lowey
					<br />
					Dannenberg P.C., one of the top plaintiffs’ law firms in the country.
					<br />
					<br />
					Lowey Dannenberg has been delivering landmark results in complex cases
					for more than 50 years, having recovered billions of dollars for its
					clients in a wide range of cases, involving just about every kind of
					corporate misconduct.
				</Typography>
				<Typography type="regular-12" className="mt-4 mb-2 text-center">
					Awarded by
				</Typography>
				<div className="flex flex-col lg:flex-row w-full justify-center items-center gap-4 lg:gap-10 ">
					<Image
						alt="super-lawyers"
						src={Images.superLawyersLogo}
						width={128}
						height={32}
						quality={75}
						priority
					/>
					<Image
						alt="super-lawyers"
						src={Images.avPreeminentLogo}
						width={114}
						height={36}
						quality={75}
						priority
					/>
				</div>
				<div className="hidden md:block absolute left-0 top-0">
					<div className="relative xl:h-[350px] xl:w-[350px]">
						<div className="absolute inset-0 bg-[url('/img/landing/svg/corner-bg.svg')] bg-contain bg-no-repeat rounded-[64px]" />
					</div>
				</div>
				<div className="absolute -right-10 top-[40%]">
					<div className="relative xl:h-[234.73px] xl:w-[220px]">
						<Image
							src={Images.hatLarge}
							alt="hat"
							quality={75}
							width={180}
							height={200}
							priority
							className="hidden lg:block"
						/>
					</div>
				</div>

				<div className="absolute left-4 top-[312px]">
					<div className="relative xl:h-11 xl:w-11">
						<Image src={Images.circle} alt="" fill priority />
						<div className="absolute inset-0 bg-gradient-to-br from-[rgba(128,139,247,0)] to-[rgba(128,57,223,0)] rounded-[64px] z-10" />
					</div>
				</div>
			</div>
		</div>
	);
};
